import type { ManualSection, ManualSearchHit } from '../manual.types';
import { blockText } from '../manual.renderer';
import { introduccionSection } from './introduccion';
import { dashboardSection } from './dashboard';
import { reportesSection } from './reportes';
import { cpdSection } from './cpd';
import { opensipsSection } from './opensips';
import { usuariosSection } from './usuarios';
import { auditoriaSection } from './auditoria';
import { glosarioSection } from './glosario';
import { faqSection } from './faq';

/**
 * Orden en que aparecen en el índice y en el menú lateral del manual.
 * Para agregar una sección: crea su archivo en `content/` y agrégala aquí.
 */
export const MANUAL_SECTIONS: ManualSection[] = [
  introduccionSection,
  dashboardSection,
  reportesSection,
  cpdSection,
  opensipsSection,
  usuariosSection,
  auditoriaSection,
  glosarioSection,
  faqSection
];

export const findSection = (slug?: string): ManualSection | undefined =>
  MANUAL_SECTIONS.find((s) => s.slug === slug);

/** Quita las marcas inline para que el buscador y los fragmentos se lean limpios. */
const plain = (s: string): string =>
  s
    .replace(/\*\*/g, '')
    .replace(/`/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();

/** Índice plano: un registro por tema. Se arma una sola vez al cargar el módulo. */
export const MANUAL_INDEX: ManualSearchHit[] = MANUAL_SECTIONS.flatMap((section) =>
  section.topics.map((topic) => {
    const body = plain(topic.blocks.map(blockText).join(' '));
    return {
      sectionSlug: section.slug,
      sectionTitle: section.title,
      topicId: topic.id,
      topicTitle: topic.title,
      haystack: `${section.title} ${topic.title} ${body}`.toLowerCase(),
      snippet: body.slice(0, 240)
    };
  })
);

/** Búsqueda simple: todas las palabras del query tienen que aparecer. */
export function searchManual(query: string): ManualSearchHit[] {
  const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [];
  return MANUAL_INDEX.filter((hit) => terms.every((t) => hit.haystack.includes(t))).slice(0, 25);
}
